import request from '@/utils/request'

/** 分期列表（7 视图：全部/待审核/进行中/已逾期/已退款/已完成/未通过） */
export function installmentList(data) {
  return request.post('/installment/index', data)
}

/** 分期详情（含每期账单） */
export function installmentDetail(id) {
  return request.post('/installment/detail', { id })
}

/** 创建分期：POST order_id paytype_id amount periods first_date */
export function installmentAdd(data) {
  return request.post('/installment/add', data)
}

/** 审核分期：POST id action(pass/refuse) audit_remark */
export function installmentAudit(id, action, remark) {
  return request.post('/installment/audit', { id, action, audit_remark: remark })
}

/** 确认某期已还款（未出账期补建账单并标记还款）：POST installment_id period_no */
export function installmentRepayPeriod(installmentId, periodNo) {
  return request.post('/installment/repayPeriod', { installment_id: installmentId, period_no: periodNo })
}
